<ng-container [formGroup]="form" *transloco="let t; prefix: 'loan-eligibility.guarantor'">
    <ng-container formGroupName="guarantor">
        <div class="flex flex-col gap-8 max-w-[800px] mx-auto">
            <div class="mb-10 text-center">
                <h3 class="text-black rfs:text-3xl mb-5">{{t('title')}}</h3>
                <p class="text-gray-900">{{t('description')}}</p>
            </div>
            <div class="flex flex-col gap-4">
                <div class="p-4 border border-gray-400 rounded-md">
                    <label for="checkbox-want-guarantor-1" class="checkbox-selector mb-3">
                        <input [formControlName]="'wantGuarantor'" [value]="true" type="checkbox"
                            class="hidden" id="checkbox-want-guarantor-1">
                        <div class="checkbox-selector-content ml-3">
                            <div class="flex items-center gap-2">
                                <span class="checkbox-selector-text font-semibold">{{t('need-guarantor')}}</span>
                            </div>
                        </div>
                    </label>
                    <div>{{t('select-guarantor-info')}}</div>
                </div>
            </div>
            <ng-container *ngIf="form.get('guarantor.wantGuarantor')?.value === true">
                <fieldset class="flex flex-col gap-2 group/input">
                    <label
                        class="font-semibold flex items-center gap-4 text-black group-disabled:text-gray-300">
                        <div class="text-gray-950 font-semibold">{{t('birth-year')}}<span class="text-error">*</span></div>
                    </label>
                    <div
                        class="border border-gray-300 rounded-full bg-gray-50 overflow-hidden flex flex-row gap-2 items-center py-3 px-4 group-focus-within/input:text-gray-900 group-focus-within/input:border-primary-500 transition-colors duration-300 outline-none bg-white max-w-[385px]">
                        <span class="text-gray-900 font-semibold">{{t('year')}}</span>
                        <input [formControlName]="'yearBornGuarantor'" mask="9999"
                            class="text-gray-500 bg-transparent flex-1 outline-none">
                    </div>
                    <span *ngIf="hasError('yearBornGuarantor')" class="text-error">{{ 'shared.error.requiredField' |
                        transloco }}</span>
                </fieldset>
                <div class="flex flex-col gap-4">
                    <div class="text-black flex flex-row items-center font-semibold gap-4">
                        <div class="text-gray-950 font-semibold">{{t('family-status')}}<span class="text-error">*</span></div>
                    </div>
                    <div class="flex flex-wrap gap-4">
                        <label role="button" for="radio-marriage-status-guarantor-1"
                            class="wizard-selection-item">
                            <input [formControlName]="'marriageStatusGuarantor'" [value]="'single'"
                                type="radio" class="hidden" id="radio-marriage-status-guarantor-1">
                            <div class="wizard-selection-content">
                                <span class="wizard-selection-text font-semibold">{{t('single')}}</span>
                            </div>
                        </label>
                        <label role="button" for="radio-marriage-status-guarantor-2"
                            class="wizard-selection-item">
                            <input [formControlName]="'marriageStatusGuarantor'" [value]="'married'"
                                type="radio" class="hidden" id="radio-marriage-status-guarantor-2">
                            <div class="wizard-selection-content">
                                <span class="wizard-selection-text font-semibold">{{t('married')}}</span>
                            </div>
                        </label>
                        <label role="button" for="radio-marriage-status-guarantor-3"
                            class="wizard-selection-item">
                            <input [formControlName]="'marriageStatusGuarantor'"
                                [value]="'cohabitation'" type="radio" class="hidden"
                                id="radio-marriage-status-guarantor-3">
                            <div class="wizard-selection-content">
                                <span
                                    class="wizard-selection-text font-semibold">{{t('cohabitation')}}</span>
                            </div>
                        </label>
                    </div>
                    <span *ngIf="hasError('marriageStatusGuarantor')" class="text-error">{{ 'shared.error.requiredField'
                        | transloco }}</span>
                </div>
                <div class="flex flex-col gap-4">
                    <div class="text-black flex flex-row items-center font-semibold gap-4">
                        <div class="text-gray-950 font-semibold">{{t('how-many-children')}}<span class="text-error">*</span></div>
                    </div>
                    <div class="flex flex-wrap gap-1 md:gap-4">
                        <label role="button" for="radio-children-guarantor-0"
                            class="wizard-selection-item">
                            <input [formControlName]="'childrenGuarantor'" [value]="'0'"
                                type="radio" class="hidden" id="radio-children-guarantor-0">
                            <div class="wizard-selection-content min-w-[53px] sm:min-w-[56px]">
                                <span class="wizard-selection-text font-semibold">0</span>
                            </div>
                        </label>
                        <label role="button" for="radio-children-guarantor-1"
                            class="wizard-selection-item">
                            <input [formControlName]="'childrenGuarantor'" [value]="'1'"
                                type="radio" class="hidden" id="radio-children-guarantor-1">
                            <div class="wizard-selection-content min-w-[53px] sm:min-w-[56px]">
                                <span class="wizard-selection-text font-semibold">1</span>
                            </div>
                        </label>
                        <label role="button" for="radio-children-guarantor-2"
                            class="wizard-selection-item">
                            <input [formControlName]="'childrenGuarantor'" [value]="'2'"
                                type="radio" class="hidden" id="radio-children-guarantor-2">
                            <div class="wizard-selection-content min-w-[53px] sm:min-w-[56px]">
                                <span class="wizard-selection-text font-semibold">2</span>
                            </div>
                        </label>
                        <label role="button" for="radio-children-guarantor-3"
                            class="wizard-selection-item">
                            <input [formControlName]="'childrenGuarantor'" [value]="'3'"
                                type="radio" class="hidden" id="radio-children-guarantor-3">
                            <div class="wizard-selection-content min-w-[53px] sm:min-w-[56px]">
                                <span class="wizard-selection-text font-semibold">3</span>
                            </div>
                        </label>
                        <label role="button" for="radio-children-guarantor-4"
                            class="wizard-selection-item">
                            <input [formControlName]="'childrenGuarantor'" [value]="'4'"
                                type="radio" class="hidden" id="radio-children-guarantor-4">
                            <div class="wizard-selection-content min-w-[53px] sm:min-w-[56px]">
                                <span class="wizard-selection-text font-semibold">4</span>
                            </div>
                        </label>
                        <label role="button" for="radio-children-guarantor-5"
                            class="wizard-selection-item">
                            <input [formControlName]="'childrenGuarantor'" [value]="'5+'"
                                type="radio" class="hidden" id="radio-children-guarantor-5">
                            <div class="wizard-selection-content min-w-[53px] sm:min-w-[56px]">
                                <span class="wizard-selection-text font-semibold">5+</span>
                            </div>
                        </label>
                    </div>
                    <span *ngIf="hasError('childrenGuarantor')" class="text-error">{{ 'shared.error.requiredField' |
                        transloco }}</span>
                </div>
                <div class="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-12">
                    <fieldset class="flex flex-col gap-2 group/input">
                        <label
                            class="font-semibold flex items-center gap-4 text-black group-disabled:text-gray-300">
                            <div class="text-gray-950 font-semibold">{{t('income')}}<span class="text-error">*</span></div>
                            <i class="icon-info-circle text-gray-700 text-base" customTooltip
                                [tooltipTemplate]="income"></i>
                        </label>
                        <ng-template #income> {{t('income-tooltip')}} </ng-template>
                        <div
                            class="border border-gray-300 bg-white rounded-full overflow-hidden flex flex-row gap-2 items-center py-3 px-4 group-focus-within/input:text-gray-900 group-focus-within/input:border-primary-500 transition-colors duration-300 outline-none">
                            <span class="text-gray-900 font-semibold">€</span>
                            <input [formControlName]="'householdIncomeGuarantor'" mask="separator.2"
                                [thousandSeparator]="thousandSeparator"
                                class="text-gray-500 bg-transparent outline-none flex-1">
                        </div>
                        <span *ngIf="hasError('householdIncomeGuarantor')" class="text-error">{{
                            'shared.error.requiredField' | transloco }}</span>
                    </fieldset>
                    <fieldset class="flex flex-col gap-2 group/input">
                        <label
                            class="font-semibold flex items-center gap-4 text-black group-disabled:text-gray-300">
                            <div class="text-gray-950 font-semibold">{{t('tax-per-year')}}<span class="text-error">*</span></div>
                            <i class="icon-info-circle text-gray-700 text-base" customTooltip
                                [tooltipTemplate]="taxPerYearTooltip"></i>
                        </label>
                        <ng-template #taxPerYearTooltip> {{t('tax-per-year-tooltip')}} </ng-template>
                        <div
                            class="border border-gray-300 bg-white rounded-full overflow-hidden flex flex-row gap-2 items-center py-3 px-4 group-focus-within/input:text-gray-900 group-focus-within/input:border-primary-500 transition-colors duration-300 outline-none">
                            <span class="text-gray-900 font-semibold">€</span>
                            <input [formControlName]="'taxPerYearGuarantor'" mask="separator.2"
                                [thousandSeparator]="thousandSeparator"
                                class="text-gray-500 bg-transparent outline-none flex-1">
                        </div>
                        <span *ngIf="hasError('taxPerYearGuarantor')" class="text-error">{{ 'shared.error.requiredField'
                            | transloco }}</span>
                    </fieldset>
                    <fieldset class="flex flex-col gap-2 group/input">
                        <label
                            class="font-semibold flex items-center gap-4 text-black group-disabled:text-gray-300">
                            <div class="text-gray-950 font-semibold">{{t('obligations')}}<span class="text-error">*</span></div>
                            <i class="icon-info-circle text-gray-700 text-base" customTooltip
                                [tooltipTemplate]="obligationsTooltip"></i>
                        </label>
                        <ng-template #obligationsTooltip> {{t('obligations-tooltip')}} </ng-template>
                        <div
                            class="border border-gray-300 bg-white rounded-full overflow-hidden flex flex-row gap-2 items-center py-3 px-4 group-focus-within/input:text-gray-900 group-focus-within/input:border-primary-500 transition-colors duration-300 outline-none">
                            <span class="text-gray-900 font-semibold">€</span>
                            <input [formControlName]="'householdDebtGuarantor'" mask="separator.2"
                                [thousandSeparator]="thousandSeparator"
                                class="text-gray-500 bg-transparent outline-none flex-1">
                        </div>
                        <span *ngIf="hasError('householdDebtGuarantor')" class="text-error">{{
                            'shared.error.requiredField' | transloco }}</span>
                    </fieldset>
                </div>
            </ng-container>
        </div>
    </ng-container>
</ng-container>